import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CAPSTONE } from '@rsos/constants/appNames';
import {
  _911_INFORM,
  AVIVE,
  CRG,
  CONNECTED_SITES,
} from '@rsos/constants/spatialLayers';
import { selectUserOrgByApp, selectUserPermissionsByApp } from '@rsos/sinatra';
import { captureException } from '@rsos/utils/sentry';
import { fetchSpatialLayers } from '../actions';
import canViewSpatialLayers from '../utils/canViewSpatialLayers';

const layerPermissions = [_911_INFORM, AVIVE, CRG, CONNECTED_SITES];

const useFetchSpatialLayers = () => {
  const [isFetched, setIsFetched] = useState(false);

  const dispatch = useDispatch();

  const sinatra = useSelector(state => state.sinatra);
  const user = sinatra.user;
  const org = useMemo(() => selectUserOrgByApp(sinatra, CAPSTONE), [sinatra]);
  const userPermissions = useMemo(() => {
    return selectUserPermissionsByApp(user, CAPSTONE);
  }, [user]);
  const capabilities = useSelector(
    state => state.psaps.currentPSAP?.activeCapabilities,
  );

  const hasAnySpatialLayerAccess = useMemo(() => {
    const hasPerms = userPermissions?.some(p => layerPermissions.includes(p));
    const hasAccess = canViewSpatialLayers(capabilities);
    return hasPerms || hasAccess;
  }, [userPermissions, capabilities]);

  // Fetch spatial layers if user has access to any
  useEffect(() => {
    if (hasAnySpatialLayerAccess && org?.id && !isFetched) {
      dispatch(fetchSpatialLayers(org.id))
        .catch(error => {
          captureException(error);
        })
        .finally(() => {
          setIsFetched(true);
        });
    }
  }, [dispatch, hasAnySpatialLayerAccess, isFetched, org?.id]);

  return isFetched;
};

export default useFetchSpatialLayers;
